import { useEffect, useState } from 'react';
import Loader from '@sber-site/sbercraft-nova-kit/components/Loader/Loader';

import { useStyles } from '../../LoaderContext';
import App from './App';

import * as css from './index.css';

export default function Retention(preferences) {
    useStyles(css);
    const [isServer, setIsServer] = useState(true);

    useEffect(() => {
        setIsServer(false);
    }, []);    
    return isServer ? (
        <div className='retention-loader'>
            <Loader type='secondary' />
        </div>
    ) : (
        <App preferences={preferences} />
    );
}
